import axios from "axios"; // 引用axios
import baseConfig from "../api/config";
import {tansParams} from "@/assets/utils/common";

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    baseURL: baseConfig.baseUrl.prod,
    // baseURL: process.env.VUE_APP_BASE_API,
    timeout: 30000,
});
export const uploadUrl = baseConfig.baseUrl.prod + "/common/upload"; // 图片上传
// 把token写入请求头
service.interceptors.request.use(config => {
    config.headers['Authorization'] = 'Bearer ' + window.sessionStorage.getItem('xtoken') // 让每个请求携带自定义token 请根据实际情况自行修改
    return config
})
//get请求
export function getRequest(url, params = {}) {
    // get请求映射params参数
    let actUrl = url + '?' + tansParams(params);
    url = url.slice(0, -1);
    params = {};
    url = actUrl;
    return new Promise((resolve, reject) => {
        service.get(url, {
                params: params,
            })
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
}
//post请求
export function postRequest(url, data = {}) {
    return new Promise((resolve, reject) => {
        service.post(url, data).then(
            (response) => {
                resolve(response.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}
//put请求
export function putRequest(url, data = {}) {
    return new Promise((resolve, reject) => {
        service.put(url, data).then(
            (response) => {
                resolve(response.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}
//delete请求
export function deleteRequest(url, data = {}) {
    return new Promise((resolve, reject) => {
        service.delete(url, data).then(
            (response) => {
                resolve(response.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}
